import React from 'react';
import { useCorrectionModalContext } from './CorrectionModalContext';
import useCorrectionModal from '@/creditflowresearch/ui/components/deals/CorrectionModal/useCorrectionModal';
import IconPencil from '@creditflowresearch/uilib/Icon/IconPencil';
import IconButton from '@creditflowresearch/uilib/IconButton';
import Tooltip from '@creditflowresearch/uilib/Tooltip';

import tableStyles from '@/creditflowresearch/ui/components/deals/DealListTable/table.module.scss';
import styles from '@/creditflowresearch/ui/components/deals/DealListTable/cells/Tools/tools.module.scss';

interface IProps {
  selectedDeal: any,
}

const CorrectionButton = ({ selectedDeal }: IProps) => {
  const {
    isCorrectionModalVisible,
    showCorrectionModal,
    hideCorrectionModal,
    CorrectionModal,
  } = useCorrectionModal();

  const {
    setSelectedDeal,
    resetCorrectionForm,
    isFetching,
    isSubmitSucceed,
    sendCorrectionData,
  } = useCorrectionModalContext();

  const getDealName = (deal): string => {
    if (!deal) {
      return '';
    }

    return `${ deal.primaryIssuer.name } (${ deal.primaryIssuer.issuerTicker }) ${ deal.seriesName }`;
  };

  const handleCorrectionModal = (event) => {
    event.stopPropagation();

    if (isCorrectionModalVisible) {
      hideCorrectionModal();
    } else {
      showCorrectionModal();
      setSelectedDeal(selectedDeal);
    }
  };

  return (
    <>
      <div className={ styles.tool }>
        <div className={ tableStyles.correctionBtn }>
          <Tooltip content="Submit a Correction">
            <IconButton
              icon={ <IconPencil size={ 12 } /> }
              ariaLabel="Submit a Correction"
              dataTest="submitCorrection"
              onClick={ handleCorrectionModal }
            />
          </Tooltip>
        </div>
      </div>
      <CorrectionModal
        isFetching={ isFetching }
        isSubmitSucceed={ isSubmitSucceed }
        hideModal={ hideCorrectionModal }
        resetModal={ resetCorrectionForm }
        submitForm={ sendCorrectionData }
        isVisible={ isCorrectionModalVisible }
        deal={ {
          id: selectedDeal.id,
          name: getDealName(selectedDeal),
        } }
      />
    </>
  );
};

export default CorrectionButton;
